export default __webpack_public_path__ + "static/media/atoms-icons-play.af96bed0.svg";